/* eslint-disable react/prop-types */
import React from "react";
import addImage from '../Assets/Images/icons/add-image.png';
import uploadPDF from '../Assets/Images/icons/upload-pdf.png';
import uploadedPDF from '../Assets/Images/icons/uploaded-pdf.png'
import uploadExcelSheet from '../Assets/Images/icons/upload-excel-sheets.png';
import uploadVideo from '../Assets/Images/icons/uploadVideo.png'
import videoUploaded from '../Assets/Images/icons/videoUploaded.png'
import Edit from '../Assets/Images/icons/edit.png';

interface props {
  value: any,
  handleChange: Function,
  htmlFor: any,
  doctype: any,
  disabled?: boolean,
  labelName?: string,
}
function ImagePickerAndViewer({
  value,
  handleChange,
  htmlFor,
  doctype,
  disabled
}: props) {
  const renderPDF = () => {
    if (value?.includes("application/pdf") || value?.includes("https://twopubmedia.s3.ap-south-1.amazonaws.com/")) {
      return (
        <img
          src={uploadedPDF}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt="PDF thumbnail"
        />
      );
    } else if (value?.includes("image/")) {
      return (
        <img
          src={value}
          style={{
            width: "50px",
            maxWidth: "100%",
          }}
          alt="Uploaded image"
        />
      );
    } else {
      return (
        <img
          src={uploadPDF}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    }
  };

  const renderExcel = () => {
    if (value)
      return (
        <img
          src={uploadExcelSheet}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    return (
      <img
        src={uploadExcelSheet}
        style={{
          width: "50px",
          height: "50px",
        }}
        alt={""}
      />
    );
  };

  const renderVideo = () => {
    if (value && value !== " ")
      return (
        <div className="d-flex align-items-center">
          <img
            src={videoUploaded}
            style={{
              width: "50px",
              height: "50px",
            }}
            className="me-3"
            alt={""}
          />
        </div>
      );
    return (
      <img
        src={uploadVideo}
        style={{
          width: "50px",
          height: "50px",
        }}
        alt={""}
      />
    );
  };
  const renderImage = () => {
    if (value && value !== " ")
      return (
        <img
          src={value}
          style={{
            height: "50px",
            maxWidth: "100%",
          }}
          alt={""}
        />
      );
    return (
      <img
        src={addImage}
        style={{
          height: "50px",
          maxWidth: "100%",
        }}
        alt={""}
      />
    );
  };

  const renderDocs = () => {
    if (value && value !== " ") {
      return (
        <img
          src={uploadPDF}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    } else {
      return (
        <img
          src={uploadPDF}
          style={{
            width: "50px",
            height: "50px",
          }}
          alt={""}
        />
      );
    }
  };

  const renderMediaInput = () => {
    if (doctype === "pdf") return renderPDF();
    else if (doctype === "video") return renderVideo();
    else if (!doctype) return renderImage();
    else if (doctype === "excel") return renderExcel();
    else if (doctype === "pdf/image") return renderPDF();
    else if (doctype === "docx") return renderDocs();

    <img
      src={Edit}
      className="cursor"
      alt="Edit"
      style={{
        width: "13px",
        position: "absolute",
        right: "0",
        bottom: "0px",
      }}
    />;
  };

  return (
    <label htmlFor={htmlFor} className="custom-file-upload fas cursor ">
      {renderMediaInput()}
      <input
        id={htmlFor}
        style={{ display: "none" }}
        type="file"
        disabled={disabled}
        onChange={(e) => handleChange(e)}
        accept={
          doctype === "pdf"
            ? ".pdf"
            : doctype === "video"
              ? "video/mp4"
              : doctype === "excel"
                ? ".xls,.xlsx"
                : doctype === "docx"
                  ? ".docx, doc"
                  : doctype === "pdf/image"
                    ? "image/png, image/gif, image/jpeg, image/webp, .pdf"
                    : "image/png, image/gif, image/jpeg, image/webp"
        }
      />
    </label>
  );
}

export default ImagePickerAndViewer;
